import { motion } from "motion/react";
import type { AgentQuestionOption } from "@/hooks/use-agent-questions";

interface AgentQuestionOptionsProps {
	options: AgentQuestionOption[];
	onSelect: (label: string) => void;
	disabled?: boolean;
}

/**
 * Choice buttons for a live agent question. Free text in the chat input is
 * always a valid answer too — these are shortcuts, not the only way.
 */
export function AgentQuestionOptions({
	options,
	onSelect,
	disabled,
}: AgentQuestionOptionsProps) {
	if (!options.length) return null;

	return (
		<motion.div
			initial={{ opacity: 0, y: 6 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.2 }}
			className="flex flex-wrap gap-1.5 px-1 pb-2"
		>
			{options.map((option) => (
				<button
					key={option.label}
					type="button"
					disabled={disabled}
					onClick={() => onSelect(option.label)}
					title={option.description}
					className="px-2.5 py-1 rounded-full bg-bg-surface border border-border-subtle text-2xs leading-tight text-text-primary font-medium hover:bg-brand-50 hover:border-brand-700 transition-all disabled:bg-action-disabled-bg disabled:text-action-disabled-fg disabled:border-transparent disabled:cursor-not-allowed"
				>
					{option.label}
					{option.description ? (
						<span className="ml-1 text-text-tertiary">{option.description}</span>
					) : null}
				</button>
			))}
		</motion.div>
	);
}
